module.exports = __webpack_public_path__ + "img/5.1d98ee21.png";